import React, { useEffect } from "react";
import { X, RotateCcw } from "lucide-react";

/**
 * Simple toast with optional Undo action.
 * Props: { open, message, onUndo, onDismiss, duration=6000 }
 */
export default function Toast({ open, message, onUndo, onDismiss, duration = 6000 }) {
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => onDismiss?.(), duration);
    return () => clearTimeout(t);
  }, [open, duration, onDismiss]);

  if (!open) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] fade-up"
      data-testid="toast"
    >
      <div
        className="card flex items-center gap-4 px-4 py-3 shadow-xl"
        style={{ background: "var(--surface)", borderColor: "var(--gain)", borderLeft: "3px solid var(--gain)" }}
      >
        <span className="text-sm">{message}</span>
        {onUndo && (
          <button
            data-testid="toast-undo-button"
            className="btn-secondary !py-1 !px-3 !text-[10px] inline-flex items-center gap-1"
            onClick={() => { onUndo(); onDismiss?.(); }}
          >
            <RotateCcw size={11} /> Undo
          </button>
        )}
        <button
          data-testid="toast-close-button"
          className="btn-ghost"
          onClick={() => onDismiss?.()}
          title="Dismiss"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
